import styled from "styled-components";
import { colors } from "@/theme";

export const ProductCartHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.silverSand};
  padding-bottom: 10px;
`;

export const ProductCartHeaderLabel = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  justify-self: start;
  /* margin-bottom:10px; */
`;